module.exports = __webpack_public_path__ + "static/media/default-avatar.7ff8e8e9.jpg";